import clonedeep from 'lodash.clonedeep';
import * as types from '../lib/constants';
import { ANALYSIS_RESULT_CODE } from '../lib/apiErrorCodes';

const appInitialState = {
  info: {
    analysis: {
      analyzingStatus: '0',
      content: '',
      status: '',
    },
    id: null,
    existsPrevData: false,
    existsNextData: false,
    tags: [],
    freeTag: '',
    credibilityCheckResult: null,
    groups: [],
  },
  updateMediaContainer: true,
  mediaFullScreenMode: types.MEDIA_FULLSCREEN_MODE.windowed,
  mediaMapFullScreenMode: types.MEDIA_MAP_FULLSCREEN_MODE.windowed,
  analysisResult: '',
  isOpenMore: false,
  isOpenAnalysis: false,
  searchPosition: types.MEDIA_SEARCH_POSITION.current,
  searchOptions: {},
  previous: '/ds/timeline',
};

export default (state = appInitialState, action) => {
  switch (action.type) {
    case 'COMPANY_CHANGED': {
      return { ...appInitialState };
    }
    case 'CHANGE_WORK_RECORD': {
      const { mediaFullScreenMode, isOpenAnalysis, searchOptions, previous } =
        state;
      return {
        ...appInitialState,
        mediaFullScreenMode,
        isOpenAnalysis,
        searchOptions,
        previous,
      };
    }
    case 'SUCCESS_API_GET_WORK_RECORD': {
      const info = action.payload || {};
      const tmp = info.tags;
      const { tags } = state.info;
      info.tags = tags;
      Object.keys(info.tags).forEach(key => {
        delete info.tags[key];
      });
      Object.keys(tmp).forEach(key => {
        info.tags[key] = tmp[key];
      });
      return { ...state, info };
    }
    case 'SUCCESS_API_ANALYZE': {
      const analysis = { ...state.info.analysis, analyzingStatus: '1' };
      const info = { ...state.info, analysis };
      return { ...state, info };
    }
    case 'ERROR_API_ANALYZE': {
      const errorCode = action.payload.errorCode || '';
      const licenseExceeded =
        ((errorCode === ANALYSIS_RESULT_CODE.voiceAnalysisLicenseExceeded ||
          errorCode === ANALYSIS_RESULT_CODE.ocrLicenseExceeded) &&
          'licenseExceeded') ||
        '';
      const noLicense =
        ((errorCode === ANALYSIS_RESULT_CODE.voiceAnalysisNoLicenseInfo ||
          errorCode === ANALYSIS_RESULT_CODE.ocrNoLicenseInfo) &&
          'noLicense') ||
        '';
      const analysisTimeExceeded =
        (errorCode === ANALYSIS_RESULT_CODE.voiceAnalysisTimeExceeded &&
          'analysisTimeExceeded') ||
        '';
      const analysisResult =
        licenseExceeded || noLicense || analysisTimeExceeded;
      return { ...state, analysisResult };
    }
    case 'UPDATE_MEDIA_CONTAINER': {
      return { ...state, updateMediaContainer: !state.updateMediaContainer };
    }
    case 'SWITCH_MEDIA_MAP': {
      const { mediaMapFullScreenMode: current } = state;
      const mediaMapFullScreenMode =
        current === types.MEDIA_MAP_FULLSCREEN_MODE.windowed
          ? types.MEDIA_MAP_FULLSCREEN_MODE.fullscreen
          : types.MEDIA_MAP_FULLSCREEN_MODE.windowed;
      return { ...state, mediaMapFullScreenMode };
    }
    case 'SWITCH_MEDIA_FULLSCREEN': {
      const mediaFullScreenMode =
        state.mediaFullScreenMode === types.MEDIA_FULLSCREEN_MODE.windowed
          ? types.MEDIA_FULLSCREEN_MODE.fullscreen
          : types.MEDIA_FULLSCREEN_MODE.windowed;
      return { ...state, mediaFullScreenMode };
    }
    case 'OPEN_AND_CLOSE_MORE': {
      return { ...state, isOpenMore: !state.isOpenMore };
    }
    case 'OPEN_AND_CLOSE_ANALYSIS': {
      return { ...state, isOpenAnalysis: !state.isOpenAnalysis };
    }
    case 'UPDATE_SEARCH_POSITION': {
      return { ...state, searchPosition: action.searchPosition };
    }
    case 'OPEN_MEDIA_DETAIL': {
      const { params } = action;
      const {
        previous = appInitialState.previous,
        searchOptions = appInitialState.searchOptions,
      } = params;
      return { ...appInitialState, previous, searchOptions };
    }
    case 'SUCCESS_UPDATE_WROKRECORD_TAG': {
      // Containerに更新通知を行い、情報再取得処理を促す
      const { tags } = clonedeep(state.info);
      const info = {
        ...state.info,
        tags: tags.filter(data => data !== undefined),
      };
      return { ...state, info };
    }
    default:
      return state;
  }
};
